'use client';

import { useDevice } from '@/app/hooks';
import DialogSelector from './components/DialogSelector';
import DrawerSelector from './components/DrawerSelector';
import SheetSelector from './components/SheetSelector';
import type { ElementsSelectorProps } from './types';

export type { ElementsSelectorProps } from './types';
// 导出类型
export { HEAD_TAB } from './types';

interface ElementsSelectorDialogProps extends ElementsSelectorProps {
  // TODO: 后续需要去掉dialog
  mode?: 'dialog' | 'sheet' | 'drawer';
}

/**
 * Elements Selector Dialog 主入口
 * 根据设备类型或指定的 mode 自动选择合适的选择器组件
 */
export const ElementsSelectorDialog = ({
  isOpen,
  onClose,
  onSelect,
  remainingSelections = 6,
  maxReferenceCount,
  onDelete,
  onCreateOpen,
  disabledIds,
  onItemChange,
  allowedModalities,
  container,
  mode = 'dialog',
  pendingDeleteIds,
  setPendingDeleteIds,
}: ElementsSelectorDialogProps) => {
  const { isMobile } = useDevice();

  return mode === 'sheet' || isMobile ? (
    <SheetSelector
      isOpen={isOpen}
      onClose={onClose}
      onSelect={onSelect}
      remainingSelections={remainingSelections}
      maxReferenceCount={maxReferenceCount}
      onDelete={onDelete}
      onCreateOpen={onCreateOpen}
      disabledIds={disabledIds}
      onItemChange={onItemChange}
      allowedModalities={allowedModalities}
    />
  ) : mode === 'dialog' ? (
    <DialogSelector
      isOpen={isOpen}
      onClose={onClose}
      onSelect={onSelect}
      remainingSelections={remainingSelections}
      maxReferenceCount={maxReferenceCount}
      onDelete={onDelete}
      onCreateOpen={onCreateOpen}
      disabledIds={disabledIds}
      onItemChange={onItemChange}
      allowedModalities={allowedModalities}
      container={container}
    />
  ) : (
    <DrawerSelector
      isOpen={isOpen}
      onClose={onClose}
      onSelect={onSelect}
      remainingSelections={remainingSelections}
      maxReferenceCount={maxReferenceCount}
      onDelete={onDelete}
      onCreateOpen={onCreateOpen}
      disabledIds={disabledIds}
      onItemChange={onItemChange}
      allowedModalities={allowedModalities}
      container={container}
      pendingDeleteIds={pendingDeleteIds}
      setPendingDeleteIds={setPendingDeleteIds}
    />
  );
};
